import React from 'react';
import styled from 'styled-components';
import { AlertContent, Icon, ModalFactory } from 'components';
import { theme, toRem } from 'design';
import { IPayPeriod } from 'types';
import { formatPayPeriodLabel, isPayPeriodClosed } from 'utils/payPeriods';

// The frames draw both buttons at a fixed width rather than hugging their labels.
const Content = styled(AlertContent)`
  footer > button {
    min-width: ${toRem(194)};
  }
`;

const Period = styled.div`
  justify-content: center;
  align-items: center;
  gap: ${toRem(theme.space.sm)};
  width: 100%;
  font-size: ${toRem(theme.font.size.sm)};
`;

interface IPayPeriodConfirmModalProps {
  title: string;
  message: string;
  confirmLabel: string;
  payPeriod: IPayPeriod;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
  dataCy: string;
}

// Asks before an action on a pay period, naming its dates, with a lock when it is closed.
const PayPeriodConfirmModal = ({ title, message, confirmLabel, payPeriod, onConfirm, onClose, isLoading, dataCy }: IPayPeriodConfirmModalProps) => (
  <ModalFactory customModal isActive onClose={onClose} closeOnOutSideClick={false}>
    <Content maxWidth={609} title={title} message={message} rightActionLabel={confirmLabel} dataCy={dataCy} hideIcon centerButtons onLeftAction={onClose} onRightAction={onConfirm} isLoading={isLoading} onClose={onClose}>
      <Period data-cy={`${dataCy}-period`}>
        {formatPayPeriodLabel(payPeriod)}
        {isPayPeriodClosed(payPeriod) && <Icon icon="LockClosed" width={16} height={16} fill={theme.color.neutral[800]} label="Closed" />}
      </Period>
    </Content>
  </ModalFactory>
);

export default PayPeriodConfirmModal;
